import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../styles/login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [loginSuccess, setLoginSuccess] = useState<boolean>(false);
  
  const { login, isAuthenticated, loading: authLoading } = useAuth();

  // Auto-clear error after 5 seconds
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  // Só redireciona se autenticado E login foi bem-sucedido
  if (isAuthenticated && loginSuccess && !authLoading) {
    return <Navigate to="/dashboard" replace />;
  }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    
    if (!loading) {
      setLoading(true);
      setError(''); // Limpar erro anterior
      setLoginSuccess(false); // Reset login success

      try {
        const result = await login(email, password);
        
        if (!result.success) {
          const errorMessage = result.error || 'Credenciais inválidas. Verifique seu e-mail e senha.';
          setError(errorMessage);
          setLoginSuccess(false);
        } else {
          setError('');
          setLoginSuccess(true); // Marca login como bem-sucedido
        }
      } catch (err) {
        console.error('Erro ao fazer login:', err);
        setError('Erro ao fazer login. Tente novamente.');
        setLoginSuccess(false);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <img 
            src="/logo-bunny.png" 
            alt="PsicoAdm Logo" 
            style={{ 
              width: '60px', 
              height: '60px', 
              marginRight: '15px',
              verticalAlign: 'middle'
            }}
          />
          <span><b>Psico</b>Adm</span>
        </div>
        
        <div className="card">
          <div className="card-body login-card-body">
            <p className="login-box-msg">Faça login para iniciar sua sessão</p>
            
            {error && (
              <div className="alert alert-danger alert-dismissible" role="alert">
                <button
                  type="button"
                  className="close"
                  onClick={() => setError('')}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <i className="icon fas fa-ban"></i> {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>
              
              <div className="row">
                <div className="col-8">
                  <div className="icheck-primary">
                    <input type="checkbox" id="remember" />
                    <label htmlFor="remember">
                      Lembrar-me
                    </label>
                  </div>
                </div>
                <div className="col-4">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-block"
                    disabled={loading}
                  >
                    {loading ? 'Entrando...' : 'Entrar'}
                  </button>
                </div>
              </div>
            </form>

            <p className="mb-1">
              <button 
                type="button"
                className="btn btn-link p-0"
                style={{ textDecoration: 'none' }}
                onClick={() => alert('Funcionalidade de recuperação de senha será implementada')}
              >
                Esqueci minha senha
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;